<div class="login-page d-flex flex-column min-vh-100">
	<div class="login-main d-flex">

		<!-- Left: cover photo -->
		<div class="login-photo portal-brand-fill" [style.background-image]="coverUrl ? 'url(' + coverUrl + ')' : null">
			<div class="portal-logo logo-box"><portal-brand-logo></portal-brand-logo></div>
		</div>

		<!-- Right: form -->
		<div class="login-form-panel d-flex flex-column align-items-center justify-content-center">
			<div class="login-form-inner d-flex flex-column">
				<div class="portal-logo login-company-logo"><portal-brand-logo></portal-brand-logo></div>

				<p class="portal-muted text-center" *ngIf="loadingToken">Checking your reset link…</p>

				<ng-container *ngIf="!loadingToken && loadError">
					<h1 class="login-heading">Reset link invalid</h1>
					<p class="fp-subtext">{{ loadError }}</p>
					<button class="btn btn-primary btn-block" routerLink="/forgot-password">Request a new link</button>
					<button class="fp-back-btn" routerLink="/login">
						<i class="wq wq-chevron-left"></i>
						Back to Sign In
					</button>
				</ng-container>

				<ng-container *ngIf="!loadingToken && reset">
					<h1 class="login-heading">Set a new password</h1>
					<p class="fp-subtext">Choose a new password for <strong>{{ reset.email }}</strong>.</p>

					<form (ngSubmit)="submit()">
						<div class="form-group">
							<label for="password">New password</label>
							<input id="password" class="form-control" type="password" name="password" placeholder="Enter Password"
								[(ngModel)]="password" autocomplete="new-password" />
						</div>

						<div class="form-group">
							<label for="passwordConf">Confirm password</label>
							<input id="passwordConf" class="form-control" type="password" name="passwordConf" placeholder="Enter Password"
								[(ngModel)]="passwordConf" autocomplete="new-password" />
						</div>

						<div class="login-error portal-error" *ngIf="error">{{ error }}</div>

						<button type="submit" class="btn btn-primary btn-block" [disabled]="submitting">
							{{ submitting ? 'Saving…' : 'Reset password' }}
						</button>
					</form>

					<button class="fp-back-btn" routerLink="/login">
						<i class="wq wq-chevron-left"></i>
						Back to Sign In
					</button>
				</ng-container>
			</div>
		</div>
	</div>

	<!-- Footer bar -->
	<div class="login-footer d-flex align-items-center justify-content-between flex-wrap">
		<div class="powered-by d-flex align-items-center gap-2">
			<span>Powered by</span>
			<img class="powered-logo powered-logo-light" src="assets/img/logo/wequote-text-dark.png" alt="WeQuote" />
			<img class="powered-logo powered-logo-dark" src="assets/img/logo/wequote.svg" alt="WeQuote" />
		</div>
		<div class="footer-links d-flex gap-4">
			<button type="button" class="portal-link-button" (click)="termsModal.open()">Terms of Use</button>
			<button type="button" class="portal-link-button" (click)="privacyModal.open()">Privacy Notice</button>
		</div>
	</div>
</div>

<!-- Read-only policy popups, opened from the footer. -->
<portal-terms-modal #termsModal></portal-terms-modal>
<portal-privacy-modal #privacyModal></portal-privacy-modal>
